import { createApi } from '@reduxjs/toolkit/query/react';
import { customHandoverBaseQuery } from '../customBaseQuery';
import { AuditLogEntry, AuditLogFilters, AuditLogResponse } from '../../features/auditLog/types';

export const auditLogApi = createApi({
  reducerPath: 'auditLogApi',
  baseQuery: customHandoverBaseQuery,
  endpoints: builder => ({
    getAuditLogs: builder.query<
      AuditLogResponse,
      AuditLogFilters | void
    >({
      query: filters => {
        const params = new URLSearchParams();

        if (filters?.entityType) {
          params.set('entityType', filters.entityType);
        }

        if (filters?.entityId) {
          params.set('entityId', filters.entityId);
        }

        if (filters?.actorEmail) {
          params.set('actorEmail', filters.actorEmail);
        }

        if (filters?.createdFrom) {
          params.set('createdFrom', filters.createdFrom);
        }

        if (filters?.createdTo) {
          params.set('createdTo', filters.createdTo);
        }

        params.set('limit', String(filters?.limit ?? 100));

        return {
          url: `/audit-log?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: AuditLogResponse | AuditLogEntry[]) =>
        Array.isArray(response) ? { entries: response } : response,
    }),
  }),
});

export const { useGetAuditLogsQuery } = auditLogApi;
